<div class="modal-wrapper" *ngIf="isOpen" (click)="clickedOutside($event)">
  <div class="modal-container">
    <div class="modal-content">

        <cowing-form (statusModal)="toggleModal($event)"></cowing-form>

    </div>
  </div>
</div>
